
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 92.38 89.62"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"レイヤー 2"}},[_c('g',{attrs:{"data-name":"レイヤー 9"}},[_c('path',{attrs:{"fill":"#ddceb3","stroke":"#89620c","stroke-miterlimit":"10","stroke-width":"5.92","d":"M2.96 2.96h86.46v83.69H2.96z"}}),_c('path',{attrs:{"d":"M40.66 26.11v-10.6h8.26v10.6h10.4v-10.6h8.45v10.6h9v7.35h-9v21.12H40.66V33.45H32v28.6h41.68v7.41H32v4.29h-8.69v-40.3h-7.67v-7.34h7.67v-10.6H32v10.6zm8.26 7.35v14.42h10.4V33.45z","fill":"#84183f"}})])])])
          )
        }
      }
    